import styled from '@emotion/styled/macro';
import { Dialog } from '@mui/material';

import { InputRoot } from 'components/inputs/input/styles';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: 461,
  },
}));

export const ModalContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  padding: '0 10px',
  paddingBottom: 15,
}));

export const Section = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 8,
  // @ts-ignore
  [InputRoot]: {
    maxWidth: 290,
  },
  button: {
    maxWidth: 290,
  },
}));

export const Label = styled.span((props) => ({
  fontSize: 13,
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
}));

export const Delimiter = styled.div((props) => ({
  borderBottom: `1px solid ${props.theme.colors.container.primary}`,
  width: '100%',
}));

export const ModalLabel = styled.span((props) => ({
  fontSize: 16,
  fontWeight: 500,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.primary,
  lineHeight: '16px',
}));

export const ModalContentWrapper = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 5,
  border: `0.5px solid ${props.theme.colors.container.tertiary}`,
  backgroundColor: props.theme.colors.background,
  padding: '5px 10px',
}));

export const ModalHead = styled.div(() => ({
  display: 'flex',
  padding: '10px 0 10px 10px',
  justifyContent: 'space-between',
}));

export const ErrorText = styled.div((props) => ({
  color: props.theme.colors.error.main,
  fontSize: 12,
}));
